import styled from 'styled-components/macro';

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
`;

export default ButtonsWrapper;
